import React, { useState } from 'react';
import 'boxicons/css/boxicons.min.css';
import { Link } from 'react-router-dom';
import './Header.scss';
import mainLogo from '../../../assets/images/mainLogo.jpg';

const Header = () => {
    const [activeTab, setActiveTab] = useState(null);
    const [menuOpen, setMenuOpen] = useState(false);
    const [openDropdown, setOpenDropdown] = useState(null);

    const toggleMenu = () => setMenuOpen(!menuOpen);
    const handleTabClick = (index) => {
        if (activeTab === index) {
            setActiveTab(null);
        } else {
            setActiveTab(index);
        }
    };
    const handleLinkClick = () => {
        setMenuOpen(false);
        setActiveTab(null);
    };


    const navItems = [
        { title: 'About Us', link: '/about' },
        {
            title: 'Meet Our Team', items: [
                { title: 'Providers', link: '/clinical-team' },
                { title: 'Staff', link: '/meet-our-team' }
            ]
        },
        { title: 'Our Services', link: '/service' },
        {
            title: 'Who We Help', items: [
                { title: 'Facilities', link: '/facilities-page' },
                { title: 'Patients and Families', link: '/patients-and-families' }
            ]
        },
        { title: 'Careers', link: '/careers-and-culture' },
        { title: 'Provider Portal', link: 'https://app.varehabphysicians.com/' }
    ];

    return (
        <header className="header">
            <nav className="navbar">
                <div className="logo-name">
                    <Link onClick={handleLinkClick} to="/"><img src={mainLogo} alt="" /></Link>
                </div>
                <div className={`menu-icon ${menuOpen ? 'open' : ''}`} onClick={toggleMenu}>
                    <i className='bx bx-menu'></i>
                </div>
                <div className={`nav-content ${menuOpen ? 'open' : ''}`}>
                    <ul className="nav-items">
                        {navItems.map((item, index) => (
                            <li
                                key={index}
                                className={`nav-item ${item.items ? 'has-dropdown' : ''}`}
                                onMouseEnter={() => window.innerWidth > 1218 ? setOpenDropdown(index) : null}
                                onMouseLeave={() => window.innerWidth > 1218 ? setOpenDropdown(null) : null}
                            >
                                {item.link ? (
                                    <Link to={item.link} onClick={handleLinkClick}>{item.title}</Link>
                                ) : (
                                    <span onClick={() => window.innerWidth <= 1218 ? handleTabClick(index) : null}>
                                        {item.title}
                                        <i className={`bx ${activeTab === index ? 'bx-chevron-down' : 'bx-chevron-right'}`}></i>
                                    </span>
                                )}
                                {item.items && (
                                    <ul className={`dropdown ${window.innerWidth <= 1218 ? (activeTab === index ? 'open' : '') : (openDropdown === index ? 'open' : '')}`}>
                                        {item.items.map((subItem, subIndex) => (
                                            <li key={subIndex} className="subListItem">
                                                <Link to={subItem.link} onClick={handleLinkClick}>{subItem.title}</Link>
                                            </li>
                                        ))}
                                    </ul>
                                )}
                            </li>
                        ))}
                    </ul>
                    <div className="contact-info">
                        <button className="get-in-touch">
                            <Link onClick={handleLinkClick} to="/contact-us">Get in Touch</Link>
                        </button>
                    </div>
                </div>
            </nav>
        </header>
    );
};

export default Header;